import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2564">
      <div className="dark" data-id="element-2565">
        <Hero data-id="element-2566" />
      </div>
      <WhyUs data-id="element-2567" />
      <ByTheNumbers data-id="element-2568" />
      <Services data-id="element-2569" />
      <HowItWorks data-id="element-2570" />
      <FAQ data-id="element-2571" />
      <Reviews data-id="element-2572" />
      <CtaBanner data-id="element-2573" />
    </main>;
}